import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export interface UserProfile {
  accountStatus: "active" | "pending_deletion" | "deleted";
  deletionCancellationToken: string | null | undefined;
  deletionScheduledFor: string | null | undefined;
  deletionRequested: boolean;
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  userHandle: string;
  connectedTo: string;
  verified: boolean;
  status: boolean;
  createdAt: string;
  updatedAt: string;
  favoriteProperties?: string[];
  fcmToken?: string | null;
}

const userProfileStore = (set: any) => ({
  profile: null as UserProfile | null,
  loading: false,
  error: null as string | null,
  
  setProfile: (profileData: UserProfile) => {
    set(() => ({
      profile: profileData,
      loading: false,
      error: null,
    }));
  },
  
  setLoading: (loading: boolean) => {
    set(() => ({ loading }));
  },
  
  setError: (error: string | null) => {
    set(() => ({ error, loading: false }));
  },
  
  clearProfile: () => {
    set(() => ({
      profile: null,
      loading: false,
      error: null,
    }));
  },
});

const useUserProfileStore = create(
  devtools(
    persist(userProfileStore, {
      name: "userProfile",
    })
  )
);

export default useUserProfileStore; 